import React, { useState, useEffect } from 'react';
import { CircularLoading, BeatLoading } from 'respinner';
import { bem, classnames, use } from '../../lib';
export const Spinner = ({ className, delay, type, size, relative }) => {
    const [show, setShow] = useState(delay === undefined);
    function handleDelay() {
        setShow(true);
    }
    useEffect(() => {
        if (delay !== undefined) {
            const timeout = setTimeout(handleDelay, delay);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, []);
    if (!show) {
        return null;
    }
    if (!type)
        type = 'spinner';
    let sizeVal = 20;
    switch (size) {
        case '1':
            sizeVal = 10;
            break;
        case '2':
            sizeVal = 20;
            break;
        case '3':
            sizeVal = 30;
            break;
        case '4':
            sizeVal = 40;
            break;
        case '5':
            sizeVal = 50;
            break;
    }
    return (React.createElement("div", { className: classnames(className, bem('spinner', use(relative, '--relative'))) },
        type === 'beat' && (React.createElement(BeatLoading, { count: 4, size: sizeVal, className: bem('spinner__svg', '--beat') })),
        type === 'spinner' && (React.createElement(CircularLoading, { duration: 1, className: bem('spinner__svg', '--circular') }))));
};
//# sourceMappingURL=Spinner.js.map